import React from "react";
import PageHeaderLight from "../../../components/shared/PageHeaderLight";
import DashboardHeaderProfileWidget from "../../../components/widgets/DashboardHeaderProfileWidget";
import RefereeDashboardAside from "./RefereeDashboardAside";
import "../../Dashboard.css";
import "../../RefereeJury.css";

export default function RefereeDashboardLayout({
  profile,
  onProfileUpdated,
  assignments,
  selectedCourseId,
  onSelectCourse,
  translate,
  showSidebar = true,
  showProfileHeader = true,
  children,
}) {
  return (
    <div className="participant-dashboard referee-dashboard-layout">
      <div id="main" role="main" className="main page-background">
        <PageHeaderLight />
        <div className="container participant-dashboard__container pt-3 pb-5">
          <div className="row pt-2 align-items-start participant-dashboard__row">
            <div className={`${showSidebar ? "col-lg-9" : "col-12"} participant-dashboard__main`}>
              {showProfileHeader && <header className="participant-dashboard__header">
                <div className="participant-dashboard__header-inner">
                  <DashboardHeaderProfileWidget
                    profile={profile}
                    onProfileUpdated={onProfileUpdated}
                    showManageProfile={false}
                  />
                </div>
              </header>}
              {children}
            </div>
            {showSidebar && (
              <RefereeDashboardAside
                assignments={assignments}
                selectedCourseId={selectedCourseId}
                onSelectCourse={onSelectCourse}
                translate={translate}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
